<template lang="pug">
.spinner( :style='style' )
  .spinner-frame
    .spinner-proper
      .spinner-inner
    .spinner-frame
      .spinner-proper
        .spinner-inner
      .spinner-frame
        .spinner-proper
          .spinner-inner
        .spinner-frame
          .spinner-proper
            .spinner-inner
          .spinner-frame
            .spinner-proper
              .spinner-inner
            .spinner-frame
              .spinner-proper
                .spinner-inner
              .spinner-frame
                .spinner-proper
                  .spinner-inner
                .spinner-frame
                  .spinner-proper
                    .spinner-inner
                  .spinner-frame
                    .spinner-proper
                      .spinner-inner
                    .spinner-frame
                      .spinner-proper
                        .spinner-inner
                      .spinner-frame
                        .spinner-proper
                          .spinner-inner
                        .spinner-frame
                          .spinner-proper
                            .spinner-inner
                          .spinner-frame
                            .spinner-proper
                              .spinner-inner
                            .spinner-frame
                              .spinner-proper
                                .spinner-inner
</template>

<script lang="js">

export default {
  name: 'spinner',
  mixins: [],
  components: {},
  props: {
    radius: {
      type: [ String, Number ],
      default: '32px'
    },
    thickness: {
      type: [ String, Number ],
      default: '2px'
    },
    color: String,
    speed: String,
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {
    style() {
      let radius = this.radius
      if ( typeof this.radius === 'number' || /^\d+$/.test( radius )) {
        radius = `${this.radius}px`
      }
      return {
        height: `calc(2 * ${radius})`,
        width: `calc(2 * ${radius})`,
        '--w-border': this.thickness,
        '--c-border': this.color,
        '--spinner-speed': this.speed,
      }
    }
  }
}
</script>

<style lang="scss">
.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100px;
  height: 100px;
  transform: translate(-50%,-50%);
  &-frame {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    animation: spin var(--spinner-speed, 24s) linear infinite;
    box-sizing: border-box;
    overflow: hidden;
  }
  &-proper {
    position: absolute;
    top: 34%;
    left: 50%;
    bottom: 33%;
    right: 0;
    box-sizing: border-box;
    overflow: hidden;
  }
  &-inner {
    position: absolute;
    top: -100%;
    left: -100%;
    bottom: -100%;
    right: 0;
    box-sizing: border-box;
    border-style: solid;
    border-width: var(--w-border, 2px);
    border-color: var(--c-loader, var(--c-border, rgba(100,255,255,0.6)));
    /* border-top-width: 0px; */
    border-radius: 100%;
    /* box-shadow: 0 0 2px rgba(100,255,255,1), inset 0 0 2px rgba(100,255,255,1); */
  }
}
@keyframes spin {
  0% {
    transform: rotate(23deg);
  }
  100% {
    transform: rotate(388deg);
  }
}
</style>
